/* tslint:disable */
/* eslint-disable */

import React, { FunctionComponent } from 'react';
import { ViewProps } from 'react-native';
import { Svg, GProps, Path } from 'react-native-svg';
import { getIconColor } from './helper';

interface Props extends GProps, ViewProps {
  size?: number;
  color?: string | string[];
}

let ExpandO: FunctionComponent<Props> = ({ size, color, ...rest }) => {
  return (
    <Svg viewBox="0 0 1024 1024" width={size} height={size} {...rest}>
      <Path
        d="M170.667008 170.667008v682.665984h682.665984V170.667008H170.667008z m0-56.889344h682.665984c31.419392 0 56.889344 25.469952 56.889344 56.889344v682.665984c0 31.419392-25.469952 56.889344-56.889344 56.889344H170.667008c-31.419392 0-56.889344-25.469952-56.889344-56.889344V170.667008c0-31.419392 25.469952-56.889344 56.889344-56.889344z"
        fill={getIconColor(color, 0, '#333333')}
      />
      <Path
        d="M597.332992 227.555328H768c15.709184 0 28.444672 12.735488 28.444672 28.444672S783.70816 284.444672 768 284.444672H597.332992c-15.70816 0-28.443648-12.735488-28.443648-28.444672s12.734464-28.444672 28.443648-28.444672z"
        fill={getIconColor(color, 1, '#333333')}
      />
      <Path
        d="M768 227.555328c15.709184 0 28.444672 12.735488 28.444672 28.444672v170.667008c0 15.70816-12.735488 28.443648-28.444672 28.443648s-28.444672-12.734464-28.444672-28.443648V256c0-15.709184 12.735488-28.444672 28.444672-28.444672z"
        fill={getIconColor(color, 2, '#333333')}
      />
      <Path
        d="M617.4464 446.780416c-11.108352 11.107328-29.118464 11.107328-40.226816 0-11.107328-11.108352-11.107328-29.118464 0-40.226816l170.667008-170.667008c11.108352-11.108352 29.118464-11.108352 40.226816 0 11.108352 11.108352 11.108352 29.118464 0 40.226816L617.4464 446.780416z"
        fill={getIconColor(color, 3, '#333333')}
      />
      <Path
        d="M426.667008 796.444672H256c-15.709184 0-28.444672-12.735488-28.444672-28.444672S240.29184 739.555328 256 739.555328h170.667008c15.70816 0 28.443648 12.735488 28.443648 28.444672s-12.734464 28.444672-28.443648 28.444672z"
        fill={getIconColor(color, 4, '#333333')}
      />
      <Path
        d="M256 796.444672c-15.709184 0-28.444672-12.735488-28.444672-28.444672V597.332992c0-15.70816 12.735488-28.443648 28.444672-28.443648s28.444672 12.734464 28.444672 28.443648V768c0 15.709184-12.735488 28.444672-28.444672 28.444672z"
        fill={getIconColor(color, 5, '#333333')}
      />
      <Path
        d="M406.5536 577.219584c11.108352-11.107328 29.118464-11.107328 40.226816 0 11.107328 11.108352 11.107328 29.118464 0 40.226816L276.113408 788.113408c-11.108352 11.108352-29.118464 11.108352-40.226816 0-11.108352-11.108352-11.108352-29.118464 0-40.226816l170.667008-170.667008z"
        fill={getIconColor(color, 6, '#333333')}
      />
    </Svg>
  );
};

ExpandO.defaultProps = {
  size: 18,
};

ExpandO = React.memo ? React.memo(ExpandO) : ExpandO;

export default ExpandO;
